export default __webpack_public_path__ + "static/media/I Premiati.f390ad3a.jpg";